var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "#697582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2,2 v5 h20 v-5 h-19 v1 h18 v3 h-18 v-4 h-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2,9 v6 h20 v-6 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2,17 v5 h20 v-5 h-19 v1 h18 v3 h-18 v-4 h-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRow);
export default __webpack_public_path__ + "static/media/icon_row.c799a5a9cf42579940e84ce6c0d82801.svg";
export { ForwardRef as ReactComponent };